var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hs-button",class:_vm.className,style:({width: _vm.width, height: _vm.height, fontSize: _vm.fontSize}),attrs:{"size":_vm.size},on:{"click":function($event){$event.stopPropagation();!_vm.disable && _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }